import { render, staticRenderFns } from "./Appheader.vue?vue&type=template&id=22d5f8df"
import script from "./Appheader.vue?vue&type=script&lang=js"
export * from "./Appheader.vue?vue&type=script&lang=js"
import style0 from "./Appheader.vue?vue&type=style&index=0&id=22d5f8df&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports